import React, { useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { IconButton } from '@mui/material';
import { FileTextOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { formatDateTimeToDate, getSafe } from '../../../shared/utility';
import {
  DASHBOARD_EPR_TARGETS,
  DASHBOARD_RECENT_EPR,
} from '../../../shared/const/Routes/statePaths';
import {
  getEPRTargets,
  getRecentEPR,
} from '../../../store/actions/dashboard/dashboard';
import ActionDetails from '../../shared/ModelSelection/ReleasesSelection/ActionDetails';
import LoadingOverlay from '../../../components/UI/LoadingOverlay/LoadingOverlay';

const columns = onDetailsClick => [
  {
    field: 'ReleaseName',
    headerName: 'Release Name',
    flex: 7,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
  },
  {
    field: 'ReleaseDate',
    headerName: 'Release Date',
    flex: 2,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    valueFormatter: value => {
      return formatDateTimeToDate(value);
    },
  },
  {
    field: 'Details',
    headerName: 'Details',
    flex: 1,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    renderCell: params => (
      <IconButton
        onClick={e => {
          e.stopPropagation();
          onDetailsClick(params.row);
        }}
      >
        <FileTextOutlined />
      </IconButton>
    ),
  },
];

const EPRTable = ({ SetEPRTargetsLoading, setSelectedRow }) => {
  const dispatch = useDispatch();

  const [selectedRowId, setSelectedRowId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [detailsRow, setDetailsRow] = useState(null);

  const rows = useSelector(state => getSafe(DASHBOARD_RECENT_EPR, state));
  const targets = useSelector(state => getSafe(DASHBOARD_EPR_TARGETS, state));

  useEffect(() => {
    setLoading(true);
    dispatch(getRecentEPR());
  }, []);

  useEffect(() => {
    if (rows && rows.length > 0 && selectedRowId == null) {
      setSelectedRowId(rows[0].ReleaseId);
      setSelectedRow(rows[0]);
    }
    setLoading(false);
  }, [rows]);

  useEffect(() => {
    if (!rows) return;
    const selectedRow = rows.find(row => row.ReleaseId == selectedRowId);
    if (selectedRow) {
      SetEPRTargetsLoading(true);
      dispatch(
        getEPRTargets(selectedRow.ReleaseProjectId, selectedRow.ReleaseId)
      );
    }
  }, [selectedRowId]);

  useEffect(() => {
    SetEPRTargetsLoading(false);
  }, [targets]);

  const handleRowClick = params => {
    setSelectedRowId(params.id);
    setSelectedRow(params);
  };

  const handleDetailsClick = row => {
    setDetailsRow(row);
  };

  const handleCloseDetails = () => {
    setDetailsRow(null);
  };

  const getDetailsContent = () => {
    if (detailsRow) {
      return (
        <ActionDetails rowData={detailsRow} onCancel={handleCloseDetails} />
      );
    }
    return <></>;
  };

  return (
    <LoadingOverlay loading={loading}>
      {getDetailsContent()}
      <DataGrid
        rows={rows}
        columns={columns(handleDetailsClick)}
        getRowId={row => row.ReleaseId}
        onRowClick={handleRowClick}
        hideFooter
        disableColumnFilter
        disableColumnMenu
        disableColumnSelector
        disableDensitySelector
      />
    </LoadingOverlay>
  );
};

export default EPRTable;
